import { render, staticRenderFns } from "./survey-type-form.vue?vue&type=template&id=5528748c"
import script from "./survey-type-form.component.ts?vue&type=script&lang=ts&external"
export * from "./survey-type-form.component.ts?vue&type=script&lang=ts&external"
import style0 from "./survey-type-form.vue?vue&type=style&index=0&id=5528748c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports